module.exports = __webpack_public_path__ + "static/media/Janna.3c0e532b.png";